import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

import { createArray } from 'app/utils/array';

interface Props {
  nbLines?: number;
  width?: number;
}

const LINE_HEIGHT = 15;

function getTopPosition(lineIndex: number): number {
  return LINE_HEIGHT * lineIndex * 2;
}

const ListPlaceholder: FC<Props> = ({ nbLines = 3, width = 182 }) => (
  <ContentLoader width={300}>
    {createArray(nbLines).map((_, index) => {
      const y = getTopPosition(index);
      return <rect key={index} x={0} y={y} width={width} height={LINE_HEIGHT} />;
    })}
  </ContentLoader>
);

ListPlaceholder.displayName = 'ListPlaceholder';

export default ListPlaceholder;
